<script>
  import { t, locale, locales } from "../i18n.js";
  export let settings;
  let tmp = settings;
  let loading_data = true;
  let shorctuts_scenes = [];
  import { fade, fly } from 'svelte/transition';
  export let userdata;
  import { Swiper, SwiperSlide } from "swiper/svelte";
  // Import Swiper styles
  import "swiper/css";
  import "swiper/css/free-mode";
  import "swiper/css/navigation";
  import "swiper/css/thumbs";
  import "swiper/css/scrollbar";
  import {get, writable} from 'svelte/store';

  import { disabled_icons, showing_intro } from '../store.js';

  let dis_icon = get(disabled_icons);

  disabled_icons.subscribe(value => {
    // console.log('disabled icons ' + value);
		dis_icon = value;
	});


  let show_intro = true;

  showing_intro.subscribe(value => {
    show_intro = value;
  });

  let current_scene;

  import { active_scene } from '../store.js';

  

  let blur_enabled = false;

  import { blur } from '../store.js';
    blur.subscribe(value => {
		  blur_enabled = value;
	  });

  import { loaded_components } from '../store.js';
  import { shortcuts } from '../store.js';
  import { sidebar } from '../store.js';

  let _shortcuts = false;

  shortcuts.subscribe(value => {
		_shortcuts = value;

    if (
      value == true
    ) {
      sidebar.update(n => false);
    }
	});

    $loaded_components = [...$loaded_components, 'shortcuts'];

  const onProgress = (e) => {
      const [swiper, progress] = e.detail;
      
    }

  let searched_tags = null;
  let cf_field = null;
  let filter_by = settings.components[4].scenes;
  let name_by = settings.components[4].titles;
  // nájdenie, aké scény sa majú zobraziť v shortcuts

  function read_scenes_from_settings() {

    switch (filter_by) {
      case 'all':
          settings.scenes.forEach(({id, enabled, order, name}) => {
            if (
              enabled == true
            ) {
              shorctuts_scenes = [...shorctuts_scenes, {
                "id" : id, 
                "order" : order,
                "title" : name
              }];
            }
          });
          
        break;
      case 'tag' :
          settings.scenes.forEach(({id, tags}) => {
            if (
              id == settings.configuration['start_scene']
            ) {
              searched_tags = tags;
              

              settings.scenes.forEach(({id, tags, order, name}, index) => {
                if (
                  JSON.stringify(tags.sort()) == JSON.stringify(searched_tags.sort())
                ) {
                  shorctuts_scenes = [...shorctuts_scenes, {
                    "id" : id,
                    "tags" : tags,
                    "order" : order, 
                    "title" : name
                  }] 
                }
              });
            }
          });
        break;
    }
    
    loading_data = false;
  }
  read_scenes_from_settings();

  // import required modules
  import { FreeMode, Navigation, Thumbs, Scrollbar, Autoplay} from "swiper";
  
  let thumbsSwiper = null;



  
  let width = 0;
  let inverval_timer;
  let auto_play = false;
  let active_slide_index = 0;
  let auto_play_timeout = 2000;

  const setThumbsSwiper = (e) => {
    const [swiper] = e.detail;
    // set Thumbs swiper instance
    setTimeout(() => {
      thumbsSwiper = swiper;
    });
  };


  function swiper_next() {
    var krpano = document.getElementById("krpanoSWFObject");
    swiper_autoplay_stop();

    if (thumbsSwiper) {
      thumbsSwiper.slideNext(200);
      thumbsSwiper.updateSlidesClasses();

      active_slide_index = thumbsSwiper.activeIndex;


      shorctuts_scenes.forEach(({id, title}, index) => {              
        
            if (
              index ==  active_slide_index
            ) {
              console.log(title);     
              // krpano.call("loadscene(praha_" + title + ", null, MERGE, BLEND(1))");       
              // krpano.set("view.hlookat", 90);   
              
              // thumbsSwiper.slideTo(index);
              
                return;
            }
          });

      // const panoName = settings.scenes[thumbsSwiper.activeIndex].id;
      // var krpano = document.getElementById("krpanoSWFObject");
      // // krpano.call("loadscene(" + panoName + ");");
      // krpano.call("loadscene(" + panoName + ", null, MERGE, BLEND(1))");
      // krpano.set("view.hlookat", settings.scenes[thumbsSwiper.activeIndex].hlookat);
      // krpano.set("view.vlookat", settings.scenes[thumbsSwiper.activeIndex].vlookat);


      
    }
  }

  function swiper_prev() {
    var krpano = document.getElementById("krpanoSWFObject");
    swiper_autoplay_stop();

    if (thumbsSwiper) {  
      thumbsSwiper.slidePrev(200);
      //thumbsSwiper.updateSlidesClasses();
      //active_slide_index = thumbsSwiper.activeIndex;

      // const panoName = settings.scenes[thumbsSwiper.activeIndex].id;
      // var krpano = document.getElementById("krpanoSWFObject");
      // // krpano.call("loadscene(" + panoName + ");");
      // krpano.call("loadscene(" + panoName + ", null, MERGE, BLEND(1))");
      // // krpano.set("view.hlookat", settings.scenes[thumbsSwiper.activeIndex].hlookat);
      // // krpano.set("view.vlookat", settings.scenes[thumbsSwiper.activeIndex].vlookat);


      active_slide_index = thumbsSwiper.activeIndex;


      shorctuts_scenes.forEach(({id, title}, index) => {              
        
            if (
              index ==  active_slide_index
            ) {
              // console.log(title);     
              // krpano.call("loadscene(praha_" + title + ", null, MERGE, BLEND(1))"); 
              // krpano.set("view.hlookat", 90);         
              
              // thumbsSwiper.slideTo(index);
              
                return;
            }
          });


      
    }
  }

  function swiper_autoplay_stop() {
    auto_play = false;
    clearInterval(inverval_timer);
    width = 0;
    if (thumbsSwiper) {
      auto_play = false;
      thumbsSwiper.autoplay.stop();  
    }
  }
  function swiper_autoplay_start() {
    auto_play = true;
    //move();
    thumbsSwiper.autoplay.start();
    clearInterval(inverval_timer);
    width = 0;
    if (
      auto_play
    ) {
      inverval_timer = setInterval(function() { 
        width++
      }, auto_play_timeout / 70);
    }
  }

  function move() {
    // console.log('alert');
    thumbsSwiper.updateSlidesClasses();
    var krpano = document.getElementById("krpanoSWFObject");
    clearInterval(inverval_timer);
    width = 0;
    if (
      auto_play
    ) {
      inverval_timer = setInterval(function() { 
        width++
      }, auto_play_timeout / 70);
    }
      // active_slide_index = thumbsSwiper.activeIndex;
      // const panoName = settings.scenes[thumbsSwiper.activeIndex].id;
      // var krpano = document.getElementById("krpanoSWFObject");
      // // krpano.call("loadscene(" + panoName + ");");
      // krpano.call("loadscene(" + panoName + ", null, MERGE, BLEND(1))");
      // // krpano.set("view.hlookat", settings.scenes[thumbsSwiper.activeIndex].hlookat);
      // // krpano.set("view.vlookat", settings.scenes[thumbsSwiper.activeIndex].vlookat);

      active_slide_index = thumbsSwiper.activeIndex;


      shorctuts_scenes.forEach(({id, title}, index) => {              
        
            if (
              index ==  active_slide_index
            ) {
              // console.log(title);     
             krpano.call("loadscene(praha_" + title + ", null, MERGE, BLEND(1))");       
              krpano.set("view.hlookat", 90); 
              // thumbsSwiper.slideTo(index);
              
                return;
            }
          });
  }

    // Zmena aktívnej scény
  function set_active_scene(e) {
    console.log(e);
    var krpano = document.getElementById("krpanoSWFObject");
    swiper_autoplay_stop();
    
    const panoName = settings.scenes[e].id;
    
    thumbsSwiper.updateSlidesClasses();

    shorctuts_scenes.forEach(({id, title}, index) => {              
        
        if (
          title ==  e
        ) {
          // console.log(title);     
          // krpano.call("loadscene(praha_" + title + ", null, MERGE, BLEND(1))");    
          // krpano.set("view.hlookat", 90);   
          thumbsSwiper.slideTo(index);
          
          // thumbsSwiper.slideTo(index);
          
            return;
        }
      });

    
      
    //krpano.call("loadscene(" + panoName + ", null, MERGE, BLEND(1))");
    // krpano.set("view.hlookat", settings.scenes[e].hlookat);
    // krpano.set("view.vlookat", settings.scenes[e].vlookat);
    if (thumbsSwiper != null) {
      // thumbsSwiper.slideTo(e);
      // active_slide_index = thumbsSwiper.activeIndex;
    }
  }


  let sortBy = {col: "order", ascending: true};

  function order_scenes () {
    loading_data = true;
    // zmena poradia podĺa order ! 
    let sortModifier = (sortBy.ascending) ? 1 : -1;
    
    let sort = (a, b) => 
      (a["order"] < b["order"]) 
      ? -1 * sortModifier 
      : (a["order"] > b["order"]) 
      ? 1 * sortModifier 
      : 0;

    settings["scenes"] = settings["scenes"].sort(sort);
    loading_data = false;
  }

  order_scenes();

  import { active_components } from '../stores.js';
  import { last_used_component } from '../stores.js';
  
  let showing;
  let last_component;

  active_components.subscribe(value => {
		showing = value;
	});

  last_used_component.subscribe(value => {
		last_component = value;
	});

  // odobratie komponentu z poľa aktívnych prvkov
  function change_active_component($component) {
    if (
      showing.includes($component)
    ) {
      active_components.update(n => n.filter( item => item !== $component));
      last_used_component.update(n => '');

    }

    else {
      active_components.update(n => [...n, $component]);
      last_used_component.update(n => $component);
    }
    
    //    
    console.log(showing);
    
  }

  active_scene.subscribe(value => {
    
    if (value != undefined && value != 'undefined') {
      current_scene = value.toLowerCase();
      
      // console.log(current_scene  +' !');
      let element = document.getElementsByClassName("swiper-slide");
      
  	
      for (let index = 0; index < element.length; index++) {
        element[index].classList.remove("swiper-slide-active");  
      }

      if (
        current_scene != null ||
        current_scene != 'undefined' ||
        current_scene != undefined ||
        current_scene != ''
      ) {


        if (thumbsSwiper != null && thumbsSwiper != undefined) {
          

          shorctuts_scenes.forEach(({id, title}, index) => {              
            if (
              id == current_scene && thumbsSwiper
            ) {
              // thumbsSwiper.slideTo(index);
                return;
            }
          });


      //    
        }
      }      
    }

	});

  let new_titles = ['Národní muzeum', 'Budova Spořitelny', 'Pražská burza', 'Německé divadlo', 'Hotel Termin', 'Hotel Wilson', 'Neorenesanční dům', 'Městský park –Vrchlického sady', 'Budova rychlozboží', 'Historická budova Hlavního nádraží', 'Pomník Woodrowa Wilsona', 'Historická budova Hlavního nádraží'];
</script>


{#if loading_data == false}
  <div class="shortcuts-icon" class:active="{_shortcuts === true}" class:hide_blur="{blur_enabled === true || dis_icon == true}" on:click="{() => shortcuts.update(n => !n)}" on:click="{() => change_active_component('shortcuts')}"></div>

  <div id="shortcuts" class="scene-thumbnails-tour" class:active="{_shortcuts === true}">
    <img id="woow" src="{userdata['base_path']}assets/images/woow-logo.svg" alt="logo" on:click="{() => window.open("https://woowstudio.com/")}"/>
  <Swiper
    navigation={true}
    thumbs={{ swiper: thumbsSwiper }}
    modules={[FreeMode, Navigation, Thumbs]}
    class="mySwiper2"
  />

  <Swiper
    on:swiper={setThumbsSwiper}
    spaceBetween={10}
    slidesPerView = 'auto'
    centeredSlides = true
    watchSlidesProgress={true}
    scrollbar={{ draggable: true }}
    
    
    on:slideChange={() => move()}
    modules={[FreeMode, Navigation, Thumbs, Scrollbar, Autoplay]}
    class="mySwiper"
    >

    {#each settings["scenes"] as scene, i}
      {#each shorctuts_scenes as item, index}
        {#if item.id == scene.id}
          <SwiperSlide id={scene.id} class="item">
            <img class:active="{current_scene == scene.id}"
              src="{userdata['base_path']}assets/krpano/{scene.thumb}"
              alt={scene.id}
              on:click={() => set_active_scene(i)}
            />
            {#if name_by == 'title'}
            <!-- <p>{scene.name}</p>    -->

            <p>{new_titles[index]}</p>   
            {:else if name_by == 'number'}
            <p>{index + 1}</p>   
            {:else}
            <p>{scene[name_by]}</p>   
            {/if}

            
          </SwiperSlide>
        {/if}
    {/each}
  {/each}
    
  </Swiper>
  <div class="progress-bar">
    <div class="progress-bar-0" />
    <div id="progress" class="progress-bar-100" style="width: {width}%;"/>  
  </div>
  <div class="control-bar">
    <p class="title">{$t("components")["shortcuts"]['auto-tour']}</p>
    <div class="controls-items">
      <div class="control-option previous" on:click="{() => swiper_prev()}" />
        {#if thumbsSwiper != null && auto_play == true}
          <div class="control-option stop" on:click="{() => swiper_autoplay_stop()}" />
        {:else}
          <div class="control-option play" on:click="{() => swiper_autoplay_start()}" />
        {/if}
      <div class="control-option next" on:click="{() => swiper_next()}"/>
    </div>
    <p class="pagination">
      {#if thumbsSwiper != null} 
        <span class="current">{active_slide_index + 1}</span>
      {/if}
      
      /
      <span class="all">{shorctuts_scenes.length}</span>
    </p>
  </div>
</div>
{/if}    

<style lang="scss">
// -------------- SHORTCUTS je nastylovany v global.scss -------------------------------
#woow {
  cursor: pointer;
  right: 0;
  position: absolute;
  z-index: 9;
  top: -48px;
}

  </style>
